import type { FunctionComponent } from "react";
import { DrawerPane } from "owa-drawer";
import type { OwaHeaderPaneProps } from "owa-header-types";
import loc from "owa-localize";
import { observer } from "owa-mobx-react";
import { LazyTeamsChatList } from "owa-teams-embed-client";
import { teamsChatPaneHeaderText } from "./TeamsChatPane.locstring.json";
import { bodyContainer } from "./TeamsChatPane.scss";

const defaultExport: FunctionComponent<OwaHeaderPaneProps> = observer(function TeamsChatPane(props) {
    return (<DrawerPane paneId={props.paneId} headerText={loc(teamsChatPaneHeaderText)} bodyClassName={bodyContainer} preserveContentOnDismiss={true} role={"complementary"}>
            <LazyTeamsChatList />
        </DrawerPane>);
}, "TeamsChatPane");

export default defaultExport;
